import { render, staticRenderFns } from "./mainDashboard.vue?vue&type=template&id=3ff37ca2&"
import script from "./mainDashboard.vue?vue&type=script&lang=js&"
export * from "./mainDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports